import { UserResponse } from "@/models/user/UserResponse";

function setUserData(user?: UserResponse | null) {
    if (user == null || user == undefined) return;
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('role', JSON.stringify(user.role));
}

function removeUserData() {
    localStorage.removeItem('user');
    localStorage.removeItem('role');
} 

export { removeUserData, setUserData };
